import { Scene3D } from '@/components/motion/Scene3D';
import { CoinMark, type CoinCode } from './CoinMark';
import type { CSSProperties } from 'react';

const coins: CoinCode[] = ['USDT', 'BTC', 'ETH', 'SOL'];

/** The affiliate destination stays separate from the local demo calculator. */
export function JoinCard({ clickUrl, accent }: { clickUrl: string; accent: string }) {
  return (
    <section
      className="moon-join"
      aria-labelledby="moon-join-title"
      style={{ '--moon-accent': accent } as CSSProperties}
    >
      <div className="moon-join-copy">
        <p className="moon-eyebrow">Gee Family × Moon</p>
        <h2 id="moon-join-title">
          Bir sonraki adım,
          <br />
          <span>Moon’da.</span>
        </h2>
        <p>
          Gee Family referans bağlantısıyla platformu keşfet. Hesap açma ve işlem adımları Moon
          üzerinden devam eder.
        </p>
        <a
          href={clickUrl}
          target="_blank"
          rel="noreferrer noopener sponsored"
          className="moon-button moon-button-primary"
        >
          Moon’da hesap aç <span aria-hidden="true">↗</span>
        </a>
        <div className="moon-join-coins">
          <span className="moon-coin-stack" aria-hidden="true">
            {coins.map((code) => (
              <CoinMark key={code} code={code} className="size-7" />
            ))}
          </span>
          <span>USDT · BTC · ETH · SOL</span>
        </div>
      </div>
      <Scene3D className="moon-join-scene" violet />
    </section>
  );
}
